import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin, MessageCircle } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0B1120] text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-orange flex items-center justify-center">
                <span className="text-white font-extrabold text-lg leading-none">D</span>
              </div>
              <div>
                <div className="font-extrabold text-white text-lg">Digital Hights</div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Pune · India</div>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Pune's specialist Real Estate Digital Marketing Agency — building qualified lead pipelines for developers, builders, and channel partners.
            </p>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2.5 text-sm">
              <li><a data-testid="footer-link-home" href="#home" className="hover:text-orange transition-colors">Home</a></li>
              <li><a data-testid="footer-link-services" href="#services" className="hover:text-orange transition-colors">Services</a></li>
              <li><a data-testid="footer-link-industries" href="#industries" className="hover:text-orange transition-colors">Industries</a></li>
              <li><a data-testid="footer-link-contact" href="#contact" className="hover:text-orange transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Services</h4>
            <ul className="space-y-2.5 text-sm">
              <li>Real Estate Lead Generation</li>
              <li>Google Ads & Meta Ads</li>
              <li>Landing Page Development</li>
              <li>Performance Marketing</li>
              <li>SEO Services</li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a data-testid="footer-phone-link" href={`tel:${BUSINESS.phone}`} className="flex items-center gap-2 hover:text-orange transition-colors">
                  <Phone size={14} /> {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a data-testid="footer-email-link" href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 hover:text-orange transition-colors break-all">
                  <Mail size={14} /> {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={14} /> {BUSINESS.location}
              </li>
            </ul>

            <div className="flex items-center gap-3 mt-5">
              <a href={BUSINESS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-social-whatsapp" aria-label="WhatsApp" className="w-9 h-9 rounded-full bg-white/5 hover:bg-orange transition-colors flex items-center justify-center">
                <MessageCircle size={16} />
              </a>
              <a href="#" data-testid="footer-social-facebook" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/5 hover:bg-orange transition-colors flex items-center justify-center">
                <Facebook size={16} />
              </a>
              <a href="#" data-testid="footer-social-instagram" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/5 hover:bg-orange transition-colors flex items-center justify-center">
                <Instagram size={16} />
              </a>
              <a href="#" data-testid="footer-social-linkedin" aria-label="LinkedIn" className="w-9 h-9 rounded-full bg-white/5 hover:bg-orange transition-colors flex items-center justify-center">
                <Linkedin size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Digital Hights. All rights reserved.</div>
          <div>Built for real estate growth in Pune.</div>
        </div>
      </div>
    </footer>
  );
};
